import { BrainCircuit, FileUp } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../components/ui/Button'
import { PageHeader } from '../../components/ui/PageHeader'

export function ReviewPage() {
  const navigate = useNavigate()

  return (
    <div className="content-page">
      <PageHeader
        title="错题复习"
        description="错题只有通过订正和二次验证，才算真正解决。"
      />

      <section className="empty-state">
        <span className="empty-state__icon" aria-hidden="true">
          <BrainCircuit size={34} strokeWidth={1.5} />
        </span>
        <h2>还没有错题记录</h2>
        <p>上传最近试卷或完成入学诊断后，系统会按错因生成复习队列。</p>
        <Button
          leadingIcon={<FileUp size={17} />}
          onClick={() => navigate('/materials')}
        >
          上传最近试卷
        </Button>
      </section>
    </div>
  )
}
